/* eslint-disable @typescript-eslint/no-explicit-any */
import { fetchAPI } from 'libs/apis'
import i18n from 'config/i18n'

import { LIMIT_PAGE } from 'helpers/constants/common'

import type {
  IProductCategorySingleProps,
  IProductCategoryQueryParams,
  IProductCategoryFormProps,
} from './model'
import { AxiosRequestConfig } from 'axios'
import { IParamForSubmit } from 'libs/apis/helper'
import { STATUS } from 'types'

export const findAll = async (
  params: IProductCategoryQueryParams,
  options?: AxiosRequestConfig,
): Promise<{ body: IProductCategorySingleProps[]; totals: number }> => {
  const withDefaultParams: IParamForSubmit = {
    _limit: LIMIT_PAGE,
    isActive: params?.isActive || true,
    ...params,
  }

  if (withDefaultParams?.isActive === STATUS.ALL) {
    delete withDefaultParams.isActive
  }

  const newParams = {
    ...withDefaultParams,
    nameTh: params.nameTh?.trim(),
  }

  const productCategories = await fetchAPI({
    apiUrl: window._env_.REACT_APP_API_URL,
    method: 'GET',
    path: '/v1/product/category',
    params: newParams,
    options,
  })

  if (productCategories.status !== 200) {
    throw new Error(i18n.t('error:notFound.title'))
  }

  return {
    body: productCategories.body as IProductCategorySingleProps[],
    totals: Number(productCategories.headers['x-total-count']),
  }
}

export const findOneById = async (
  id: string,
): Promise<IProductCategorySingleProps> => {
  const productCategories = await fetchAPI({
    apiUrl: window._env_.REACT_APP_API_URL,
    method: 'GET',
    path: `/v1/product/category/${id}`,
  })

  if (productCategories.status !== 200) {
    throw new Error(i18n.t('error:notFound.title'))
  }

  let body = productCategories.body

  if (Array.isArray(body)) {
    body = body[0]
  }

  return body as IProductCategorySingleProps
}

export const create = async (
  body: IProductCategoryFormProps,
): Promise<IProductCategorySingleProps> => {
  const productCategories = await fetchAPI({
    apiUrl: window._env_.REACT_APP_API_URL,
    method: 'POST',
    path: '/v1/product/category',
    options: { data: body },
  })

  if (productCategories.status !== 201) {
    throw new Error(i18n.t('error:notFound.title'))
  }

  return productCategories.body as IProductCategorySingleProps
}

export const update = async (
  id: string,
  body: IProductCategoryFormProps,
): Promise<IProductCategorySingleProps> => {
  const productCategories = await fetchAPI({
    apiUrl: window._env_.REACT_APP_API_URL,
    method: 'PATCH',
    path: `/v1/product/category/${id}`,
    options: { data: body },
  })

  if (productCategories.status !== 200) {
    throw new Error(i18n.t('error:notFound.title'))
  }

  return productCategories.body as IProductCategorySingleProps
}
